<template>
  <div class="app-container">
    <div class="chatbot">
      <div class="renew2_wrapper">
        <div class="messages" ref="messageContainer">
          <div v-for="(msg, index) in messages" :key="index" :class="['message', msg.sender]">
            <div class="bubble" v-html="formatMessage(msg.text)"></div>
          </div>
          <div v-if="isTyping" class="message bot">
            <div class="bubble typing-indicator">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ChatbotDemoComponent',
  props: {
    companyInfo: {
      type: String,
      required: false
    },
    motivation: {
      type: String,
      required: false
    },
    previousMessages: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data () {
    return {
      userInput: '',
      messages: [],
      isTyping: false
    }
  },
  watch: {
  },
  computed: {
    greetingMessage () {
      let message = 'こんにちは！AI面接練習(β版)へようこそ。\n\n'
      message += '私はあなたの面接練習をサポートするAIヤギです。実際の面接官の役割を演じながら、様々な質問をさせていただきます。\n\n'

      message += '準備はよろしいでしょうか？それでは、面接練習を始めましょう。'

      return message
    },
    firstQuestion () {
      return '最初の質問です。\n\n1.簡単な自己紹介をお願いできますか？'
    },
    firstAnswer () {
      return 'こんにちは！私はヤギと申します。\n草を食べることが得意で、山や丘を登るのが趣味です。人とのコミュニケーションも大好きで、興味を持ったものは何でも試したがる性格です。\n常に慎重ですが、興味が湧いたら大胆に挑戦します。体力には自信があり、困難な状況でも粘り強く取り組むことができます！\nどうぞよろしくお願いいたします'
    },
    secondQuestion () {
      return '自己紹介ありがとうございます、ヤギさん。非常にユニークで興味深いですね。続いての質問です。これまでの経験の中で、最も大変だったことと、それをどのように乗り越えたか教えていただけますか？'
    },
  },
  async mounted () {
    window.addEventListener('resize', this.adjustMessagesHeight)
    this.adjustMessagesHeight()
    await this.loopShowGreetingWithDelay()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.adjustMessagesHeight)
  },
  updated () {
    this.scrollToBottom()
  },
  methods: {
    showGreetingWithDelay () {
      this.isTyping = true
      setTimeout(async () => {
        await this.typeMessage('bot', this.greetingMessage)
        await setTimeout(() => {
          this.typeMessage('bot', this.firstQuestion)
        }, 1000)
        await setTimeout(() => {
          this.typeMessage('user', this.firstAnswer)
        }, 2000)
      }, 1000)

      setTimeout(async () => {
        this.isTyping = true
        await setTimeout(() => {
          this.typeMessage('bot', this.secondQuestion)
        }, 3000)
      }, 3000)
    },
    async typeMessage (sender, text) {
      if (sender === 'bot') {
        this.isTyping = true
      }

      this.messages.push({
        sender: sender,
        text: text
      })

      this.$nextTick(() => this.scrollToBottom())

      if (sender === 'bot') {
        this.isTyping = false
      }
    },
    scrollToBottom () {
      const container = this.$refs.messageContainer
      if (container) {
        container.scrollTop = container.scrollHeight
      }
    },
    adjustMessagesHeight () {
      const vh = window.innerHeight * 0.01
      document.documentElement.style.setProperty('--vh', `${vh}px`)
    },
    formatMessage (text) {
      // 改行文字を<br>タグに置換
      return text.replace(/\n/g, '<br>')
    },
    async loopShowGreetingWithDelay () {
      while (true) {
        this.messages = []
        await this.showGreetingWithDelay()
        await this.delay(15000)
      }
    },
    delay (ms) {
      return new Promise((resolve) => setTimeout(resolve, ms))
    }
  }
}
</script>

<style scoped>
.app-container {
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
}

.renew2_wrapper {
  width: 768px;
  margin: 0 auto 50px;
}

.chatbot {
  width: 100%;
  position: relative;
  background: #FFFFE8;
  padding: 10px 0;
}

.messages {
  height: calc(100vh - 480px);
  overflow-y: scroll;
  border: 1px solid #ccc;
  padding: 10px;
  margin-bottom: 10px;
  background: #fff;
  border-radius: 5px;
  overflow-y: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.messages::-webkit-scrollbar {
  display: none;
}

.message {
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
}

.bubble {
  max-width: 80%;
  padding: 10px 15px;
  border-radius: 18px;
  position: relative;
  color: white;
  white-space: pre-wrap;
  word-wrap: break-word;
  font-size: 14px;
  line-height: 1.4;
}

.user {
  align-items: flex-end;
}

.user .bubble {
  background: #0F9934;
  border-bottom-right-radius: 4px;
}

.bot {
  align-items: flex-start;
}

.bot .bubble {
  background: #EFF5E9;
  color: #404040;
  border-bottom-left-radius: 4px;
}

.typing-indicator {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 15px;
}

.typing-indicator span {
  height: 10px;
  width: 10px;
  float: left;
  margin: 0 1px;
  background-color: #9E9EA1;
  display: block;
  border-radius: 50%;
  opacity: 0.4;
}

.typing-indicator span:nth-of-type(1) {
  animation: 1s blink infinite 0.3333s;
}

.typing-indicator span:nth-of-type(2) {
  animation: 1s blink infinite 0.6666s;
}

.typing-indicator span:nth-of-type(3) {
  animation: 1s blink infinite 0.9999s;
}

@keyframes blink {
  50% {
    opacity: 1;
  }
}

@media (max-width: 768px) {

  .messages {
    height: calc(100vh - 480px);
  }

  h1 {
    font-size: 24px;
  }

  p {
    font-size: 14px;
  }

  .bubble {
    font-size: 13px;
    padding: 8px 12px;
  }
}
</style>
